import React from 'react';
import PropTypes from 'prop-types';
import SalesFilterForm from '../formSection/salesFilterForm/salesFilterForm';
import TicketsFilterForm from 'components/tickets/formSection/ticketsFilterForm/ticketsFilterForm';
import SiteFilterForm from 'components/installation/siteFilterForm/siteFilterForm';
import SiteInvoiceFilterForm from 'components/installation/siteFilterForm/siteInvoiceFilterForm';
import GoLiveFilterForm from 'components/maintenance/goLiveFilterForm/goLiveFilterForm';
import PmSitiesFilterForm from 'components/maintenance/pmSitiesFilterForm/pmSitiesFilterForm';
import ApprovalCampListingFilterForm from 'components/maintenance/ApprovalCampListingFilterForm/approvalCampListingFilterForm';
import InvoiceFilterForm from 'components/maintenance/InvoiceFilterForm/InvoiceFilterForm';
import PmTicketsFilterForm from 'components/maintenance/pmTicketsFilterForm/pmTicketsFilterForm';
import RmTicketsFilterForm from 'components/maintenance/rmTicketsFilterForm/rmTicketsFilterForm';
import EmployeeFilterForm from 'components/maintenance/employeeFilterForm/employeeFilterForm';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';

import { Button } from 'react-bootstrap';
import paymentRequest from 'pages/sales/paymentRequest';

const PaymentFilter = ({
  showFilter = false,
  filterToggle,
  applyFilter,
  getZones,
  filterPreSalesListing = false,
  filterApprovalCampListing = false,
  filterTicketsListing = false,
  liveFilterDropDown = false,
  pmdropdownList = false,
  pmTicketFilter = false,
  siteFilters = false,
  rmTicketFilter = false,
  employeeFilterList = false,
  pmApprovalList = false,
  listFilterData = null,
  invoiceFilters = false,
  paymentRequestFilter = false,
  zones = [],
  status = [],
  statusId,
  isRoleId,
}) => {
  return (
    <div className={showFilter ? 'show-filter' : ''}>
      {showFilter && (
        <div className="filter-wrapper">
          <div className="filter-heading">
            <h4>Filters</h4>
            <Button onClick={filterToggle} className="close"></Button>
          </div>
          <div className="filter-body scrollbar-styling">
           
           
            {invoiceFilters && (
               <SiteInvoiceFilterForm
               applyFilter={(val) => applyFilter(val)}
               siteTypes={
                 listFilterData !== null ? listFilterData.site_types : []
               }
               assignedAreas={
                 listFilterData !== null ? listFilterData.assigned_areas : []
               }
               reportees={
                 // listFilterData !== null ? listFilterData.reportees : []
                 []
               }
               siteStatus={1}
               ageFilter={true}
             />
            )}
            {paymentRequestFilter && (
               <SiteInvoiceFilterForm
               applyFilter={(val) => applyFilter(val)}
               siteTypes={
                 listFilterData !== null ? listFilterData.site_types : []
               }
               assignedAreas={
                 listFilterData !== null ? listFilterData.assigned_areas : []
               }
               reportees={
                 // listFilterData !== null ? listFilterData.reportees : []
                 []
               }
               siteStatus={
                 listFilterData !== null ? listFilterData.site_status : []
               }
               requestFilter={true}
             />
            )}

            {siteFilters && (
              <SiteFilterForm
              applyFilter={(val) => applyFilter(val)}
              siteTypes={
                listFilterData !== null ? listFilterData.site_types : []
              }
              assignedAreas={
                listFilterData !== null ? listFilterData.assigned_areas : []
              }
              reportees={
                // listFilterData !== null ? listFilterData.reportees : []
                []
              }
              siteStatus={
                listFilterData !== null ? listFilterData.site_status : []
              }
            />
            )}

          </div>
        </div>
      )}
    </div>
  );
};

PaymentFilter.propTypes = {
  showFilter: PropTypes.bool,
  filterToggle: PropTypes.func,
  applyFilter: PropTypes.func,
  getZones: PropTypes.func,
  getAreas: PropTypes.func,
  
};

export default PaymentFilter;
